<template>
    <div class="project-create-step relative flex flex-col gap-4 overflow-y-auto border-l-[1px] border-solid border-grey-40 p-4 pt-[60px]">
        <EditionUsage :usedWhere="UsageAmountWhere.TECH_RESEARCH" :inside="true" />
        <PtIcon icon="CopilotStep" class="absolute left-0 top-0 z-10 text-[120px]"></PtIcon>
        <CreateStep
            :createStepList="stepContent"
            :isStreamProcessing="isStreamProcessing"
            :streamStarting="streamStarting"
        />
    </div>
</template>

<script setup lang="ts">
import { PtIcon } from 'patsnap-biz';
import { useStep } from '@/composables/use-step';
import CreateStep from '@/components/create-step/CreateStep.vue';
import '@/assets/icons/copilot-step.svg';
import EditionUsage from '@eureka/shared/edition-upgrade/src/components/edition/EditionUsage.vue';
import { UsageAmountWhere } from '@eureka/shared/edition-upgrade/src/constants';

const { updateStatus, analysis, stepContent, isStreamProcessing } = useStep()

defineExpose({
    updateStatus,
    analysis,
})
</script>
